import * as React from "react";
import { CustomInput } from "reactstrap";

export class Checkbox extends React.Component<any> {
    render() {
        const { inputLabel, name, id, value, onChange, disabled = false, inline = false } = this.props;

        return (
            <CustomInput
                type="checkbox"
                disabled={disabled}
                checked={!!value}
                label={inputLabel}
                name={name}
                id={id || name}
                onChange={(e: any) => onChange(e.target.checked)}
                inline={inline}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/form/fields/Checkbox.tsx